import { Vue, Component, Mixins, Watch, Ref } from 'vue-property-decorator';
import productListDataMixin from '@/components/product/ProductListDataMixin';
import { DisplayEnum } from '@/types/enum';
import { FilterDataType, NewDisplayEnum, CategroyType } from '@/types/product';
import { momentAdd, getDownToday } from '@/utils/dateUtils';
import { escapeHtml, getCurrency, centerWinOptions } from '@/utils/commonUtils';
import {
  Brand,
  GetBrandsSearchRequest,
  GetProductsMallProductNoOptionsPurchasePrice,
  Grade,
  Group,
  NCPResponse,
  ProductsSaleSettingStatusType,
} from 'supporter';

import { gridModelToExcel } from '@/utils/ncp';
import { writeExcel } from '@/utils/excel';
import { namespace } from 'vuex-class';
import store from '@/store';
import debounce from 'lodash.debounce';
import PageDateRangePicker from '@/components/board/common/PageDateRangePicker.vue';
const set = require('lodash.set');

const productModule = namespace('product');

let renderGridByProductNo: Function;
window.addEventListener(
  'message',
  function(event: any): void {
    if (typeof event === 'object' && event.data) {
      if (event.data?.freeGiftType) return;

      if (event.data.copyWin) {
        window.open(event.data.url);
      }

      if (
        event.data.modifySaleStatus ||
        event.data.modifyFrontDisplay ||
        event.data.salePeriodInfo ||
        event.data.immediateDiscount ||
        event.data.promotionText ||
        event.data.modifySalePrice ||
        event.data.modifyDelivery ||
        event.data.promotionsChange 
      ) {
        store.commit('terms/SET_POPINFO', {
          title: window.$t('PRODUCT_PRODUCTLIST_PLM_BATCH_CHANGE_RESULT'), //일괄변경 결과
          description: event.data.data,
          footBtn: true,
          subStyle: 'width:900px; max-height:800px; scroll-y:auto',
        });
        store.commit('terms/SET_NCPLAYERISSHOW', true);
        store.commit('product/SET_SEARCHPRODUCTLIST', true);
      }
    }
    if (
      event.data.batchConfirm ||
      event.data.urlDirectDisplay ||
      event.data.productJudgement ||
      event.data.modifyOption
    ) {
      store.commit('product/SET_SEARCHPRODUCTLIST', true);
    }

    if (event.data.comparingPriceSite || event.data.modifyPromotion) {
      const { successNos } = event.data.data;
      if (successNos.length && event.data.comparingPriceSite) {
        renderGridByProductNo(successNos[0], 'priceComparisonSite');
      }
      if (successNos.length && event.data.modifyPromotion) {
        renderGridByProductNo(successNos[0], 'canPromotion');
      }
    }

    if (event.data.successChangeGroupManagementCode) {
      store.commit('product/SET_SEARCHPRODUCTLIST', true);
    }
  },
  false,
);

@Component
export default class ProductListMethodsMixin extends Mixins(productListDataMixin) {
  @productModule.Mutation('SET_SEARCHPRODUCTLIST') public setIsSearch!: (isSearch: boolean) => void;
  @productModule.Getter('getIsSearchProductList') public isEmitSearch!: boolean;

  @Ref()
  protected readonly dateRangePickerRef!: PageDateRangePicker;

  @Watch('isEmitSearch')
  public onIsSearchChange(val: any): void {
    if (val) {
      this.search(this.gridProps.pageOptions.page);
    }
  }

  public get currentDateRange(): string {
    const selectVal: FilterDataType = this.filterDateData.find((data: FilterDataType): any => data.selected) || {
      value: '0',
      label: this.$t('BOARD_FAQ_TODAY') as string,
      selected: true,
    };
    return selectVal.value;
  }

  public dateData: { startYmd: string; endYmd: string } = {
    startYmd: '',
    endYmd: this.today,
  };
  public dateReceiveData = { ...this.dateData };

  public disableObject = {
    start: false,
    end: false,
  };

  private setStartYmd(): void {
    if (this.dateReceiveData.endYmd) {
      if (
        this.searchParams['periodInfo.type'] === 'SALE_END_DATE' ||
        this.searchParams['periodInfo.type'] === 'SALE_START_DATE'
      ) {
        Object.assign(this.dateData, {
          startYmd: this.dateReceiveData.startYmd,
          endYmd: momentAdd(
            this.dateReceiveData.startYmd,
            this.filterDateAddMapping[this.currentDateRange],
            'YYYY-MM-DD',
          ),
        });
      } else {
        Object.assign(this.dateData, {
          startYmd: momentAdd(this.dateReceiveData.endYmd, this.filterDateMapping[this.currentDateRange], 'YYYY-MM-DD'),
          endYmd: this.dateReceiveData.endYmd,
        });
      }
    } else {
      Object.assign(this.dateData, {
        startYmd: momentAdd(this.today, this.filterDateMapping[this.currentDateRange], 'YYYY-MM-DD'),
        endYmd: this.today,
      });
    }

    this.dateReceiveData = { ...this.dateData };
  }

  private setYmd(): void {
    this.dateData = { ...this.dateReceiveData };
    if (this.currentDateRange === '0') {
      Object.assign(this.dateData, {
        startYmd: this.today,
        endYmd: this.today,
      });

      this.disableObject.start = false;
      this.disableObject.end = false;
    } else if (this.currentDateRange === 'ALL') {
      Object.assign(this.dateData, {
        startYmd: this.DEFAULT_MIN_DATE_RANGE,
        endYmd: this.today,
      });

      this.disableObject.start = true;
      this.disableObject.end = true;
    } else {
      this.setStartYmd();
      this.disableObject.start = false;
      this.disableObject.end = false;
    }
    this.dateReceiveData = { ...this.dateData };
  }

  public setFilterUnSelected(): void {
    const oldIdx = this.filterDateData.findIndex((item: FilterDataType): any => item.selected);
    Vue.set(this.filterDateData, oldIdx, { ...this.filterDateData[oldIdx], selected: false });
  }

  public dateFilterChange(idx: number): void {
    this.setFilterUnSelected();
    Vue.set(this.filterDateData, idx, { ...this.filterDateData[idx], selected: true });

    // 퀵버튼을 클릭했을 때 종료일을 항상 오늘 기준으로 세팅
    this.dateReceiveData = {
      ...this.dateReceiveData,
      endYmd: this.today,
    };

    this.setYmd();
  }

  // ProductList > PageDateRangePicker > 에서 달력에서 일자를 수동으로 선택하면 발생하는 이벤트
  public dateDataChange({ startYmd, endYmd, isBtnSet }: any): void {
    if (!isBtnSet) {
      this.setFilterUnSelected();
      // 퀵버튼을 클릭하면 이벤트 실행 순서가 dateFilterChange -> dateDataChange 순서로 실행되기 때문에
      // 퀵버튼으로 날짜를 변경하여도 이전 날짜로 세팅되는 이슈가 있어 퀵버튼이 아닌 경우에만 dateReceiveData 를 갱신하도록 코드 옮김
      this.dateReceiveData = { startYmd, endYmd };
    }

    // 변경된 날짜로 업데이트를 하지 않으면, 수동으로 종료 일자를 선택 한 후, 오늘 버튼을 클릭하면 시작 일자가 변경되지 않음
    this.dateRangePickerRef.onDateObjectChange(this.dateReceiveData);
  }

  public keywordInfoChange(): void {
    const keywordInfoType = this.searchParams['keywordInfo.type'];
    this.keywordTexthide = keywordInfoType !== 'PRODUCT_MANAGEMENT_CD_LIKE';
  }

  public showProductManagementCdLikeGuide(): void {
    this.initPop(this.popInfo);
  }
  //****************************************
  //searchMenu related definition start
  public searchMenuBlur(elName: any): void {
    if (elName === 'brand' && this.searchParams['brandNo'] === -100) {
      this.brandsInputVal = '';
    } else if (elName === 'partner' && this.searchParams['partnerNo'] === -100) {
      this.partnerInputVal = '';
    } else if (elName === 'admin' && this.searchParams['adminNo'] === -100) {
      this.adminInputVal = '';
    }
  }

  public searchMenuFocus(elName: any, event: any): void {
    if (!this.searchParams.mallNos) {
      event.currentTarget.blur();
      alert(this.ALERT_MESSAGES.chooseMall);
    } else {
      if (elName === 'brand' && this.brandsInputVal.length) {
        this.brandsMenuIsShow = true;
      }

      if (elName === 'partner' && this.partnerInputVal.length) {
        this.partnerMenuIsShow = true;
      }

      if (elName === 'admin' && this.adminInputVal.length) {
        this.adminMenuIsShow = true;
      }
    }
  }

  private searchBrand = debounce((e: Event) => this.searchBrandsByKeyword(e), 500);
  private searchBrandsByKeyword(e: Event) {
    const value = (e.target as HTMLInputElement).value;
    const isSelectedBrand = !this.brandsMenuIsShow;
    if (!value || isSelectedBrand) return;

    this.brandsInputVal = value;
    this.fetchBrandsSearch(value);
  }

  private async fetchBrandsSearch(value: string) {
    const mallNo = Number(this.searchParams.mallNos);
    if (!mallNo || !value.length) return;

    const params: GetBrandsSearchRequest = { params: { mallNo, keyword: value } };
    const { data }: NCPResponse<Brand[]> = await this.$api.getBrandsSearch(params);
    this.brandsList = data;
  }

  public searchMenuInput(elName: any, event: Event): void {
    if (elName === 'brand') {
      this.brandsList = [];
      this.searchBrand(event);
      this.brandsMenuIsShow = true;
      this.searchParams['brandNo'] = -100;
    } else if (elName === 'partner') {
      if (!this.partnerList.length) {
        this.$api
          .getMallsContractedPartnersByMallNo({ pathParams: { mallNo: this.searchParams.mallNos } })
          .then(({ data }): void => {
            this.partnerList = data.filter(item => {
              return item.partnerStatus === 'ACTIVE' && ( item.contractStatus === 'ACTIVE' || item.contractStatus === 'SUSPEND' );
            });
            this.partnerMenuIsShow = true;
          });
      } else {
        this.partnerMenuIsShow = true;
      }

      this.searchParams['partnerNo'] = -100;
    } else if (elName === 'admin') {
      if (!this.adminList.length) {
        this.$api
          .getAdminsServiceMerchandisers({ params: { mallNo: this.searchParams.mallNos } })
          .then(({ data }): void => {
            this.adminList = data;
            this.adminMenuIsShow = true;
          });
      } else {
        this.adminMenuIsShow = true;
      }

      this.searchParams['adminNo'] = -100;
    }
  }

  public searchMenuSelected(valueName: 'adminNo' | 'brandNo' | 'partnerNo', item: NewDisplayEnum): void {
    this.searchParams[valueName] = Number(item.value);
    if (valueName === 'adminNo') {
      this.adminInputVal = item.text;
      this.adminMenuIsShow = false;
    } else if (valueName === 'brandNo') {
      this.brandsInputVal = item.text;
      this.brandsMenuIsShow = false;
    } else if (valueName === 'partnerNo') {
      this.partnerInputVal = item.text;
      this.partnerMenuIsShow = false;
    }
  }

  public adminSearchMenuClose(): void {
    this.adminMenuIsShow = false;
  }
  public brandsSearchMenuClose(): void {
    this.brandsMenuIsShow = false;
  }
  public partnerSearchMenuClose(): void {
    this.partnerMenuIsShow = false;
  }
  //searchMenu menu related definition end
  //****************************************

  public applyStatusTypeChange(): void {
    const applyStatusType = this.searchParams['applyStatusType'];
    switch (applyStatusType) {
      case 'REGISTRATION_READY':
      case 'APPROVAL_READY':
      case 'APPROVAL_REJECTION':
      case 'SALE_AGREEMENT_READY':
      case 'SALE_AGREEMENT_REJECTION':
        this.isAllCheckBoxDisabled = true;
        break;
      case 'ALL':
      case 'FINISHED':
      case 'AFTER_APPROVAL_READY':
      case 'AFTER_APPROVAL_REJECTION':
        this.isAllCheckBoxDisabled = false;
        this.saleStatusData = ['ON_PRE_SALE', 'WAITING_SALE', 'ON_SALE', 'END_SALE'];
        this.saleSettingStatusData = ['AVAILABLE_FOR_SALE', 'STOP_SELLING', 'PROHIBITION_SALE'];
        break;
    }
  }

  public categoriesDataHandle(array: []): CategroyType[] {
    if (array.length) {
      return array.map(
        (item: any): CategroyType => {
          const value = item.displayCategoryNo || item.categoryNo;
          const label = item.displayCategoryName || item.name;
          const children = this.categoriesDataHandle(item.children || item.child);
          return { value, label, children };
        },
      );
    } else {
      return [];
    }
  }

  public getMallCategories(): void {
    const mallNo = this.searchParams['mallNos'];
    const categoryCondition = this.searchParams['categoryCondition.type'];
    this.categoiesCascade.initDepthData();
    if (categoryCondition === 'DISPLAY') {
      if (!mallNo) return alert(this.ALERT_MESSAGES.chooseMall);
      this.$api
        .getDisplayCategoriesTree({
          params: {
            mallNo: Number(mallNo),
          },
        })
        .then(({ data }: any): void => {
          this.categoiesCascade.setDepthData(1, this.categoriesDataHandle(data));
        });
    } else if (categoryCondition === 'STANDARD') {
      const mallNos = this.malls.filter((item): boolean => item.value !== '');
      this.$api
        .getStandardCategoriesTree({
          params: {
            mallNo: mallNos[0].value,
          },
        })
        .then(({ data }: any): void => {
          this.categoiesCascade.setDepthData(1, this.categoriesDataHandle(data.tree));
        });
    }
  }

  public mallNoChange(): void {
    const mallNo = this.searchParams['mallNos'];
    //1.clear searchMenu related data
    this.brandsInputVal = '';
    this.searchParams['brandNo'] = -100;
    this.partnerInputVal = '';
    this.searchParams['partnerNo'] = -100;
    this.adminInputVal = '';
    this.searchParams['adminNo'] = -100;
    if (mallNo) {
      //2. get category
      this.getMallCategories();
      //3.
      this.getMemberGrades();
      this.getMemberGroups();
    } else {
      this.categoiesCascade.initDepthData();
      this.memberGradeNo = [this.memberGradeNo[0]];
      this.memberGroupNo = [this.memberGroupNo[0]];
      this.searchParams['memberGradeNo'] = 0;
      this.searchParams['memberGroupNo'] = 0;
      this.customCheckboxReset();
    }
  }

  public mallNoIsExist(): void {
    if (!this.searchParams['mallNos']) {
      alert(this.ALERT_MESSAGES.chooseMall);
    }
  }

  public getMemberGrades(): void {
    const params = { mallNo: Number(this.searchParams['mallNos']) };
    this.$api.getMemberGrades({ params }).then(({ data }): void => {
      if (data.length) {
        const firstItem = this.memberGradeNo[0];
        this.memberGradeNo = [firstItem].concat(
          data
            .filter((item: Grade): boolean => item.used)
            .map(
              (item: Grade): DisplayEnum => {
                return { value: item.no.toString(), label: item.name };
              },
            ),
        );
        this.memberGradeNo.push({ value: '0', label: this.pDI18n('NOT_SET') });
      }
    });
  }

  public getMemberGroups(): void {
    const params = { mallNo: Number(this.searchParams['mallNos']) };
    this.$api.getMemberGroups({ params }).then(({ data }): void => {
      if (data.length) {
        const firstItem = this.memberGroupNo[0];
        this.memberGroupNo = [firstItem].concat(
          data.map(
            (item: Group): DisplayEnum => {
              return { value: item.no.toString(), label: item.name };
            },
          ),
        );

        this.memberGroupNo.push({ value: '0', label: this.pDI18n('NOT_SET') });
      }
    });
  }

  public saleMethodTypeChange(): void {
    const saleMethodType = this.searchParams['saleMethodType'];
    if (saleMethodType === 'PURCHASE') {
      this.isCommissionTypeDisabled = true;
    } else {
      this.isCommissionTypeDisabled = false;
    }
  }

  public commissionTypeChange(): void {
    this.isSupplyPriceViewShow = false;
    this.isCommissionRateView = false;
    const commissionType = this.searchParams['commission.type'];
    switch (commissionType) {
      case 'RATE':
        this.isCommissionRateView = true;
        break;
      case 'SUPPLY_PRICE':
        this.isSupplyPriceViewShow = true;
        break;
    }
  }

  public async getCustomProperty(): Promise<any> {
    let { data: gridCustomColumns } = await this.$api.getGridLayouts({ params: { gridName: 'PRODUCT_GRID' } });

    this.$api.getCustomPropertyUsable().then(({ data }): void => {
      this.customProperties = data.filter((item: any): boolean => item.used);

      const propertyNames = this.customProperties.map(({ propertyNo, propertyName, multiSelectionEnabled }: any): any => {
          return {
            header: propertyName,
            name: `customProperties${propertyNo}`,
            align: 'center',
            formatter: ({ row }): string => {
              const customProperties = row.customProperties;
              const usedCustomProperties = customProperties.map((item): string[] => item.propertyNo === propertyNo && item.propertyValue);
              const propertyValues = usedCustomProperties.filter((item): string => item).join(',');
              const property = customProperties.find((property): boolean => property.propertyNo === propertyNo);

              if (customProperties.length && property) {
                if (typeof multiSelectionEnabled === 'boolean' && !multiSelectionEnabled) {
                  return property.propertyValue;
                } else {
                  const url = `/product/popup/customProperty/${row.mallProductNo}/${propertyValues}?propertyName=${propertyName}`;

                  return `
                    <a href="javascript:onclick=window.open('${url}','customProperty','${centerWinOptions(523, 237,)}')">
                      ${property.propertyValue}
                    </a>
                  `;
                }
              }

              return '-';
            },
            copyOptions: { customValue: (value): string => value },
          };
        },
      );

      propertyNames.forEach((column: any): void => {
        this.gridProps.columns.splice(this.gridProps.columns.length - 1, 0, column);
      });

      this.newColumnsCustomization = [];
      this.excelColumns.splice(0);
      if (gridCustomColumns && gridCustomColumns.length) {
        gridCustomColumns.forEach(({ columnName, visible }: any): void => {
          const column = this.gridProps.columns.find((item: any): boolean => item.name === columnName) as any;
          if (column && visible) {
            this.newColumnsCustomization.push(column);

            if (this.excelColumnsKeys.includes(column.name) || column.name.includes('customProperties')) {
              const excelColumn = {
                header: column.header,
                name: column.name === 'mallProductNo' ? 'productNo' : column.name,
              };

              this.excelColumns.splice(this.excelColumns.length, 0, excelColumn);
            }
          }
        });
      } else {
        this.gridProps.columns.forEach(({ header, name }: any): void => {
          if (this.excelColumnsKeys.includes(name) || name.includes('customProperties')) {
            const excelColumn = {
              header,
              name: name === 'mallProductNo' ? 'productNo' : name,
            };
            this.excelColumns.splice(this.excelColumns.length, 0, excelColumn);
          }
        });
      }

      const tuiGrid = this.getTuiGrid();
      if (this.newColumnsCustomization.length) {
        tuiGrid.invoke('setColumns', this.newColumnsCustomization);
      } else {
        tuiGrid.invoke('setColumns', this.gridProps.columns);
      }

      this.search();

      if (this.malls.length === 1) {
        this.getMallCategories();
        this.getMemberGrades();
        this.getMemberGroups();
      }
    });
  }

  public setCustomProperty(propertyNos: string[]): void {
    this.searchParams['customPropertyValueNos'] = propertyNos.join(',');
  }

  public setSaleStatus(): void {
    const saleStatus = this.$refs.saleStatus as any;
    const { allCheckedStatusList, allStatusCheck, allSettingCheck } = saleStatus;
    const saleStatusObj = {
      'saleStatus.isAll': allStatusCheck,
      'saleSettingStatus.isAll': allSettingCheck,
      'saleStatus.types': '',
      'saleSettingStatus.types': '',
    };
    const saleStatusTypes: { [propName: string]: any } = {};
    const saleSettingStatusTypes: { [propName: string]: any } = {};

    allCheckedStatusList.forEach((status: string): void => {
      switch (status) {
        case 'WAITING_SALE':
          saleStatusTypes.WAITING_SALE = 1;
          break;
        case 'ON_SALE':
          saleStatusTypes.ON_SALE = 1;
          break;
        case 'END_SALE':
          saleStatusTypes.END_SALE = 1;
          break;
        case 'STOP_SELLING':
          saleSettingStatusTypes.STOP_SELLING = 1;
          break;
        case 'PROHIBITION_SALE':
          saleSettingStatusTypes.PROHIBITION_SALE = 1;
          break;
        case 'ON_PRE_SALE':
          saleStatusTypes.ON_PRE_SALE = 1;
          break;
        case 'AVAILABLE_FOR_SALE':
          saleSettingStatusTypes.AVAILABLE_FOR_SALE = 1;
          break;
      }
    });

    saleStatusObj['saleSettingStatus.types'] = Object.keys(saleSettingStatusTypes).join();
    saleStatusObj['saleStatus.types'] = Object.keys(saleStatusTypes).join();

    Object.assign(this.searchParams, saleStatusObj);
  }

  public cateCascadeTypeChange(categoryObj: any): void {
    Object.assign(this.searchParams, categoryObj);
  }

  public stockRangeChange(range: any): void {
    switch (range) {
      case '0':
        this.searchParams['stockRange.type'] = 'NONE';
        this.searchParams['stockRange.stockCnt'] = 0;
        break;
      case '1':
        this.searchParams['stockRange.type'] = 'EXIST';
        this.searchParams['stockRange.stockCnt'] = 1;
        break;
      case '5':
      case '10':
      case '50':
      case '100':
        this.searchParams['stockRange.type'] = 'LE';
        this.searchParams['stockRange.stockCnt'] = Number(range);
        break;
      default:
        this.searchParams['stockRange.type'] = 'ALL';
        delete this.searchParams['stockRange.stockCnt'];
        break;
    }
  }

  public customCheckboxReset(): void {
    this.searchParams['customPropertyValueNos'] = '';
    (this.$refs.customCheckbox as any).innerCheckedNos = [];
  }

  public reset(): void {
    this.searchParams = { ...this.searchParamsResetData };
    this.keywordTexthide = true;

    this.isAllCheckBoxDisabled = false;
    this.saleStatusData = ['ON_PRE_SALE', 'WAITING_SALE', 'ON_SALE', 'END_SALE'];
    this.saleSettingStatusData = ['AVAILABLE_FOR_SALE', 'STOP_SELLING', 'PROHIBITION_SALE'];

    this.isCommissionTypeDisabled = false;
    this.isSupplyPriceViewShow = false;
    this.isCommissionRateView = false;
    this.customCheckboxReset();
    this.dateFilterChange(3);

    const keywordInfoType = this.searchParams['keywordInfo.type'];

    this.mallNoChange();
    // this.setStartYmd();
    Object.assign(this.dateData, {
      startYmd: momentAdd(this.today, this.filterDateMapping[this.currentDateRange], 'YYYY-MM-DD'),
      endYmd: this.today,
    });
    this.dateReceiveData = { ...this.dateData };

    (this.$refs.productContent as any).showCustomProperty = true;

    this.invalidKeywordSwitch = false;
    this.invalidKeywordText = '';
  }

  public paramsSearch = {};
  public paramsExcel = {};

  public search(page: number = 1, resetSummary: boolean = true): void {
    this.setSaleStatus();
    this.$nextTick((): void => {
      const params: { [propName: string]: any } = {};
      Object.keys(this.searchParams).forEach((prop: any): void => {
        if (this.searchParams[prop] !== -100 && this.searchParams[prop] !== '') {
          Object.assign(params, { [prop]: this.searchParams[prop] });
        }
      });

      if (
        resetSummary &&
        this.dateReceiveData.startYmd === this.DEFAULT_MIN_DATE_RANGE &&
        (this.$refs.productsSummary as any).selectedSummary
      ) {
        this.dateFilterChange(3);
        Object.assign(this.dateData, {
          startYmd: momentAdd(this.today, this.filterDateMapping[this.currentDateRange], 'YYYY-MM-DD'),
          endYmd: this.today,
        });
        this.dateReceiveData = { ...this.dateData };
      }

      if (resetSummary) {
        (this.$refs.productsSummary as any).resetSelect();
      }

      if (this.currentDateRange === 'ALL') {
        this.dateReceiveData.startYmd = this.DEFAULT_MIN_DATE_RANGE;
      }

      Object.assign(params, {
        'periodInfo.period.startYmdt': this.dateReceiveData.startYmd + ' 00:00:00',
        'periodInfo.period.endYmdt': this.dateReceiveData.endYmd + ' 23:59:59',
        page,
      });

      if (this.searchParams['saleStatus.isAll']) {
        delete params['saleStatus.types'];
      }

      if (!this.searchParams['saleStatus.types']) {
        delete params['saleStatus.isAll'];
        delete params['saleStatus.types'];
      }

      if (this.searchParams['saleSettingStatus.isAll']) {
        delete params['saleSettingStatus.types'];
      }

      if (!this.searchParams['saleSettingStatus.types']) {
        delete params['saleSettingStatus.isAll'];
        delete params['saleSettingStatus.types'];
      }

      let keywords = params['keywordInfo.keywords'] || '';

      if (params['keywordInfo.type'] === 'MALL_PRODUCT_NO') {
        keywords = keywords
          .replace(/\r\n|\n/g, ',')
          .split(',')
          .filter((v: any): boolean => v.length > 0);
        keywords = keywords.map((el: any): void => el.trim());

        const flag = keywords.some((v: any): boolean => {
          return /^\d+$/.test(v) === false;
        });

        if (flag) {
          this.invalidKeywordSwitch = true;
          this.invalidKeywordText = this.pDI18n('PLM_YOU_CAN_ONLY_ENTER_NUMBERS_AND_COMMAS'); //숫자와 콤마만 입력할 수 있습니다
          return;
        }

        params['keywordInfo.keywords'] = keywords.join(',');
      } else if (params['keywordInfo.type'] === 'PRODUCT_NAME') {
        keywords = keywords
          .replace(/\r\n|\n/g, ',')
          .split(',')
          .filter((v: any): boolean => v.length > 0);
        params['keywordInfo.keywords'] = keywords.join(',');
      } else if (params['keywordInfo.type'] === 'PRODUCT_MANAGEMENT_CD') {
        const selectedData = this.filterDateData.find((item: FilterDataType): any => item.selected);
        if (selectedData?.value === 'ALL' && !keywords.length) {
          this.invalidKeywordSwitch = true;
          this.invalidKeywordText = this.pDI18n('PLM_PLEASE_ENTER_A_SEARCH_TERM'); //검색어를 입력해주세요.
          return;
        }

        keywords = keywords
          .replace(/\r\n|\n/g, ',')
          .split(',')
          .filter((v: any): boolean => v.length > 0);
        params['keywordInfo.keywords'] = keywords.join(',');
      }

      const isExsitAppliedAdditionalDiscountPrice = this.newColumnsCustomization.find(
        ({ name }: any): boolean => name === 'appliedAdditionalDiscountPrice',
      );
      const isExsitAdditionalDiscountAmount = this.newColumnsCustomization.find(
        ({ name }: any): boolean => name === 'additionalDiscountAmount',
      );

      const tuiGrid = this.getTuiGrid();
      if (params.needsAdditionalDiscountInfo === 'Y') {
        if (isExsitAppliedAdditionalDiscountPrice) tuiGrid.invoke('showColumn', 'appliedAdditionalDiscountPrice');
        if (isExsitAdditionalDiscountAmount) tuiGrid.invoke('showColumn', 'additionalDiscountAmount');
      } else {
        if (isExsitAppliedAdditionalDiscountPrice) tuiGrid.invoke('hideColumn', 'appliedAdditionalDiscountPrice');
        if (isExsitAdditionalDiscountAmount) tuiGrid.invoke('hideColumn', 'additionalDiscountAmount');
      }

      this.paramsSearch = Object.assign({}, params);

      if (params['mallNos']) {
        Object.assign(params, { mallNos: params['mallNos'].split(',').map((item: any): number => Number(item)) });
      }

      const newParams = {};
      Object.keys(params).forEach((v: any): void => {
        set(newParams, v, params[v]);
      });

      if (newParams['keywordInfo']['keywords']) {
        Object.assign(newParams['keywordInfo'], {
          keywords: newParams['keywordInfo']['keywords'].split(','),
        });
      } else {
        delete newParams['keywordInfo']['keywords'];
      }

      if (newParams['saleStatus'] && newParams['saleStatus']['isAll'] === false) {
        Object.assign(newParams['saleStatus'], {
          types: newParams['saleStatus']['types'].split(','),
        });
      }

      if (newParams['saleSettingStatus'] && newParams['saleSettingStatus']['isAll'] === false) {
        Object.assign(newParams['saleSettingStatus'], {
          types: newParams['saleSettingStatus']['types'].split(','),
        });
      }

      if (newParams['customPropertyValueNos']) {
        Object.assign(newParams, {
          customPropertyValueNos: newParams['customPropertyValueNos']
            .split(',')
            .map((no: string): number => Number(no)),
        });
      }

      this.paramsExcel = JSON.parse(JSON.stringify(newParams));

      this.$api.postProductsSearch({ data: newParams } as any).then(({ data }): void => {
        this.searchRespones.contents = data.contents.map((item): any => {
          const obj = { ...item };
          const customProperties = item.customProperties;
          customProperties.forEach((prop): void => {
            obj[`customProperties${prop.propertyNo}`] = prop.propertyValue;
          });
          
          return obj;
        });
        this.gridProps.pageOptions.perPage = this.searchParams.size || 0;
        this.gridProps.pageOptions.page = page;
        this.gridProps.pageOptions.totalCount = data.totalCount;
        store.commit('product/SET_SEARCHPRODUCTLIST', false);

        setTimeout((): void => {
          const $headerCbx = $('#tui-grid-productlist .tui-grid-cell-row-header input[type="checkbox"]');
          if (data.totalCount) {
            $headerCbx.prop('disabled', false);
          } else {
            $headerCbx.prop('disabled', true);
          }
        });
      });
    });
  }

  public onClickSummarySearch(selectedSummary: string): void {
    this.reset();
    Object.assign(this.dateData, {
      startYmd: this.DEFAULT_MIN_DATE_RANGE,
      endYmd: this.today,
    });
    const data = { ...this.dateData, isBtnSet: false };
    this.dateDataChange(data);

    this.searchParams['applyStatusType'] = 'ALL';
    delete this.searchParams['stockRange.stockCnt'];
    this.searchParams['stockRange.type'] = 'ALL';

    switch (selectedSummary) {
      case 'TOTAL':
        break;
      case 'ONSALE':
        this.saleStatusData = ['ON_SALE'];
        break;
      case 'READY':
        this.saleStatusData = ['WAITING_SALE'];
        this.saleSettingStatusData = ['AVAILABLE_FOR_SALE', 'STOP_SELLING'];
        break;
      case 'SOLDOUT':
        this.saleStatusData = ['ON_PRE_SALE', 'WAITING_SALE', 'ON_SALE', 'END_SALE'];
        this.saleSettingStatusData = ['AVAILABLE_FOR_SALE', 'STOP_SELLING'];

        this.searchParams['stockRange.stockCnt'] = 0;
        this.searchParams['stockRange.type'] = 'NONE';
        break;
      case 'APPROVALREADY':
        // this.isSubsCheckBoxDisabled = true;
        this.searchParams['applyStatusType'] = 'APPROVAL_READY';
        this.saleStatusData = [];
        this.saleSettingStatusData = [];
        break;
      case 'APPROVALREJECTION':
        // this.isSubsCheckBoxDisabled = true;
        this.searchParams['applyStatusType'] = 'APPROVAL_REJECTION';
        this.saleStatusData = [];
        this.saleSettingStatusData = [];
        break;
      case 'SALEAGREEMENTREJECTION':
        // this.isSubsCheckBoxDisabled = true;
        this.searchParams['applyStatusType'] = 'SALE_AGREEMENT_REJECTION';
        this.saleStatusData = [];
        this.saleSettingStatusData = [];
        break;
      case 'STOP':
        this.saleStatusData = ['ON_SALE'];
        this.saleSettingStatusData = ['STOP_SELLING'];
        break;
    }
    this.$nextTick((): void => {
      // this.saleStatusTypeCheckBox.randerData();
      this.search(1, false);
    });
  }

  public pageSizeChange(): void {
    this.$nextTick((): void => {
      this.search();
    });
  }

  public initPop(popInfo: any): void {
    this.setPopInfo(popInfo);
    this.setPopIsShow(true);
  }
  public async fireExcelDown(): Promise<any> {
    if (!this.searchParams['mallNos']) {
      return alert(this.pDI18n('THE_MALL_DOES_NOT_EXIST'));
    }
    Object.assign(this.paramsSearch, { mallNos: this.searchParams['mallNos'] });

    let excelData = [];
    await this.$api.getProductsExcelSearch({ params: this.paramsSearch }).then(({ data }: any): any => {
      excelData = data;
    });

    excelData = excelData.map((item: any): any => {
      const obj = { ...item };
      item.customProperties.forEach((prop): void => {
        const currentProp = this.customProperties.find(
          (propG: any): boolean => propG.propertyName === prop.name,
        ) as any;
        if (currentProp) {
          Object.assign(obj, {
            [`customProperties${currentProp.propertyNo}`]: prop.value,
          });
        }
      });
      return obj;
    });

    // const data = this.searchRespones.contents || [];
    if (excelData.length === 0) {
      alert(this.$t('COMMON_NOT_DATA'));
    } else {
      const model = gridModelToExcel(this.excelColumns);

      this.customProperties.forEach(({ propertyNo }: any): void => {
        model.formatter['customProperties' + propertyNo] = ({ row }: any): string => {
          const propertyVal = row['customProperties' + propertyNo];
          if (row.customProperties.length && propertyVal) {
            return propertyVal;
          }
          return '-';
        };
      });

      model.formatter['productName'] = ({ value }: any): string => {
        return escapeHtml(value);
      };
      model.formatter['brandName'] = ({ value }: any): string => {
        return escapeHtml(value);
      };
      model.formatter['saleMethodType'] = ({ value }: any): string => {
        if (value === 'PURCHASE') {
          return this.pDI18n('PLM_BUY'); //사입
        } else if (value === 'CONSIGNMENT') {
          return this.pDI18n('PLM_CONSIGNMENT'); //위탁
        }
        return '';
      };
      model.formatter['commissionRate'] = ({ row }: any): string => {
        if (row.saleMethodType === 'PURCHASE' || row.commission.type === 'PURCHASE_PRICE') {
          return '-';
        }
        return `${row.commission.rate}%`;
      };
      model.formatter['supplyPrice'] = ({ value, row }: any): string => {
        if (row.saleMethodType === 'PURCHASE') {
          return '-';
        }
        const isInclude = this.USMallNos.includes(row.mallNo);
        return getCurrency(value, isInclude);
      };
      model.formatter['purchasePrice'] = ({ row }: any): string => {
        if (row.saleMethodType === 'CONSIGNMENT') {
          return '-';
        }
        const isInclude = this.USMallNos.includes(row.mallNo);
        return getCurrency(row.supplyPrice, isInclude);
      };
      model.formatter['applyStatusType'] = ({ row }: any): any => {
        let text = '';
        switch (row.applyStatusType) {
          case 'REGISTRATION_READY':
            text = this.pDI18n('PLM_WAITING_FOR_REGISTRATION'); //등록대기
            break;
          case 'APPROVAL_READY':
            text = this.pDI18n('PLM_WAITING_FOR_APPROVAL'); //승인대기
            break;
          case 'APPROVAL_REJECTION':
            text = this.pDI18n('PLM_REJECTION_OF_APPROVAL'); //승인거부
            break;
          case 'SALE_AGREEMENT_READY':
            text = this.pDI18n('PLM_WAITING_FOR_SALES_AGREEMENT'); //판매합의대기
            break;
          case 'SALE_AGREEMENT_REJECTION':
            text = this.pDI18n('PLM_REJECTION_OF_SALES_AGREEMENT'); //판매합의거부
            break;
          case 'AFTER_APPROVAL_READY':
            text = this.pDI18n('PLM_WAITING_FOR_APPROVAL_AFTER_MODIFICATION'); //수정 후 승인대기
            break;
          case 'AFTER_APPROVAL_REJECTION':
            text = this.pDI18n('PLM_REJECT_APPROVAL_AFTER_MODIFICATION'); //수정 후 승인거부
            break;
          default:
            return this.pDI18n('PLM_APPROVAL_COMPLETED'); //승인완료
        }
        return text;
      };
      model.formatter['saleStatusType'] = ({ value }: any): string => {
        switch (value) {
          case 'PRE_APPROVAL_STATUS':
            return '-';
          case 'ON_PRE_SALE':
            return this.pDI18n('PLM_PRE_ORDER'); //예약판매중
          case 'WAITING_SALE':
            return this.pDI18n('PLM_WAITING_FOR_SALE'); //판매대기
          case 'ON_SALE':
            return this.pDI18n('PLM_SALE'); //판매중
          case 'END_SALE':
            return this.pDI18n('PLM_END_OF_SALE'); //판매종료
          default:
            return '';
        }
      };
      model.formatter['saleSettingStatusType'] = ({ value }: any): string => {
        switch (value) {
          case 'AVAILABLE_FOR_SALE':
            return this.pDI18n('PLM_AVAILABLE_FOR_SALE'); //판매가능
          case 'STOP_SELLING':
            return this.pDI18n('PLM_STOP_SELLING'); //판매중지
          case 'PROHIBITION_SALE':
            return this.pDI18n('PLM_PROHIBITION_OF_SALE'); //판매금지
          default:
            return '';
        }
      };
      model.formatter['frontDisplayable'] = ({ value }: any): string => {
        let val = String(value);
        let text = '';
        switch (val) {
          case 'true':
            text = this.pDI18n('PLM_DISPLAY_POSSIBLE'); //전시가능
            break;
          case 'false':
            text = this.pDI18n('PLM_NO_EXHIBITION'); //전시안함
            break;
        }
        return text;
      };
      model.formatter['reservationPeriod'] = ({ value }: any): string => {
        if (value && value.startYmdt && value.endYmdt) {
          return `${value.startYmdt} ~ ${value.endYmdt}`;
        } else {
          return '-';
        }
      };
      model.formatter['salePeriod'] = ({ value }: any): string => {
        if (value && value.startYmdt && value.endYmdt) {
          return `${value.startYmdt} ~ ${value.endYmdt}`;
        } else {
          return '-';
        }
      };
      model.formatter['salePrice'] = ({ value, row }: any): string => {
        const isInclude = this.USMallNos.includes(row.mallNo);
        return getCurrency(value, isInclude);
      };
      model.formatter['immediateDiscountAmount'] = ({ value, row }: any): string => {
        const isInclude = this.USMallNos.includes(row.mallNo);
        return getCurrency(value, isInclude);
      };
      model.formatter['appliedImmediateDiscountPrice'] = ({ value, row }: any): string => {
        const val = getCurrency(value, row.countryCd === 'US');
        if (parseInt(val, 10) <= 0) {
          return '0';
        }
        return val;
      };
      model.formatter['reservationStockCnt'] = ({ row }: any): string => {
        // const reservationStockCnt = row.reservationStockCnt;
        // if (reservationStockCnt) {
        //   return reservationStockCnt;
        // } else {
        //   return this.pDI18n('SOLD_OUT');
        // }

        if (!row.reservationPeriod) {
          return '-';
        } else {
          const reservationStockCnt = row.reservationStockCnt;
          if (reservationStockCnt) {
            return reservationStockCnt;
          } else {
            return this.pDI18n('SOLD_OUT');
          }
        }
      };
      model.formatter['stockCnt'] = ({ row }: any): string => {
        const totalCnt = row.productStock.totalCnt;
        if (totalCnt) {
          return totalCnt;
        } else {
          return this.pDI18n('SOLD_OUT');
        }
      };
      model.formatter['saleCnt'] = ({ row }: any): string => {
        return row.productStock.totalSaleCnt;
      };
      model.formatter['canPromotion'] = ({ value, row }: any): string => {
        // if (row.applyStatusType === 'REGISTRATION_READY') {
        //   return '-';
        // }
        // return value;
        const currentValue = value ? 'Y' : 'N';

        if (row.saleSettingStatusType === 'PROHIBITION_SALE') {
          return currentValue;
        }

        return currentValue;
      };
      model.formatter['priceComparisonSite'] = ({ value, row }: any): string => {
        if (row.saleStatusType === 'REGISTRATION_READY') {
          return '-';
        }
        const siteYn = !value ? 'N' : 'Y';
        if (row.saleStatusType === 'REGISTRATION_READY' || row.saleSettingStatusType === 'PROHIBITION_SALE') {
          return siteYn;
        }
        return siteYn;
      };
      model.formatter['displayCategoryNames'] = ({ value }: any): any => {
        if (!value) {
          return null;
        }
        return value.join('|');
      };
      model.formatter['groupType'] = ({ value }: any): any => {
        switch (value) {
          case 'DELIVERY':
            return this.pDI18n('PLD_GT_DELIVERY'); //배송상품군
          case 'SERVICE':
            return this.pDI18n('PLD_GT_SERVICE'); //서비스상품군
          default:
            return '';
        }
      };
      model.formatter['deliverable'] = ({ value }: any): string => {
        if (value === true) {
          return this.pDI18n('PLM_DELIVERY'); //배송
        }
        return this.pDI18n('PLM_NO_DELIVERY'); //배송안함
      };
      model.formatter['shippingAreaType'] = ({ value }: any): string => {
        switch (value) {
          case 'PARTNER_SHIPPING_AREA':
            return this.pDI18n('PLM_PARTNER_DELIVERY'); //파트너사 배송
          case 'MALL_SHIPPING_AREA':
            return this.pDI18n('PLM_SHOPPING_MALL_SHIPPING'); //쇼핑몰 배송
          default:
            return this.pDI18n('PLM_ALL'); //전체
        }
      };
      model.formatter['deliveryFeeType'] = ({ value, row }: any): string => {
        // const isInclude = this.USMallNos.includes(row.mallNo);
        // switch (value) {
        //   case 'CONDITIONAL':
        //     return `${this.pDI18n('PLM_CONDITIONALLY_FREE')}(${getCurrency(value, isInclude)})`;
        //   case 'FIXED_FEE':
        //     return `${this.pDI18n('PLM_PAID_FIXED_SHIPPING_FEE')}(${getCurrency(value, isInclude)})`;
        //   default:
        //     return this.pDI18n('PLM_FREE'); //무료
        //     break;
        // }
        switch (value) {
          case 'CONDITIONAL':
            return `${this.pDI18n('PLD_CONDITIONALLY_FREE')}(${getCurrency(
              row.freeShippingConditionAmount,
              this.USMallNos.includes(row.mallNo),
            )})`;
          case 'FIXED_FEE':
            return this.pDI18n('PLD_PAID_FIXED_SHIPPING_FEE'); //
          default:
            return this.pDI18n('PLD_FREE'); //
        }
      };
      model.formatter['deliveryCharge'] = ({ value, row }: any): string => {
        if (!row.deliverable) {
          return '';
        }
        if (!value) {
          return '0';
        }
        const isInclude = this.USMallNos.includes(row.mallNo);
        return getCurrency(value, isInclude);
      };

      model.formatter['usesDeliveryDueDate'] = ({ value, row }: any): string => {
        if (row.deliverable) {
          return value ? 'Y' : 'N';
        }
        return '-';
      };
      model.formatter['shippingCombinable'] = ({ value, row }: any): string => {
        if (row.deliverable) {
          return value ? 'Y' : 'N';
        }
        return '-';
      };
      // model.formatter['deleteBtn'] = ({row}: any): string => {
      //   if (row.saleStatusType !== 'ON_SALE' && !this.doNotDeleteProduct.includes(row.applyStatusType)) {
      //     return this.pDI18n('PLM_DELETE'); //삭제
      //   }
      //   return '';
      // };

      const excelColumn: any = {};
      this.excelColumns.forEach((column: any): void => {
        excelColumn[column.name] = column.header;
      });

      const filename = 'product_' + getDownToday();
      writeExcel(excelData, excelColumn, filename, model.formatter);
    }
  }

  public judgementRejectRenderHTML(rejectArray: any): string {
    let judgementRejectHTML = '';
    rejectArray.forEach((reason: any): void => {
      judgementRejectHTML += `<div class="table_tit mt">${this.rejectReasonInfoObj[reason.section]}</div>
      <table class="ncp_tbl grid"><colgroup><col width="170px"><col width=""></colgroup>
      <tbody><tr><th>${this.pDI18n('PLM_ITEM')}</th><th>${this.pDI18n('PLM_REGISTRATION_INFORMATION')}</th></tr>`;
      let subHTML = '';
      reason.items.forEach(({ item, detail: { data, comment } }: any): void => {
        const dataTrim = data.trim();
        const dataText = dataTrim; //$($.parseHTML(dataTrim)).text();
        const commentTrim = comment.trim();
        const commentText = $($.parseHTML(commentTrim)).text();

        // let contentArea = dataTrim.length ? dataText : commentTrim.length ? commentText : '';
        let contentArea = dataTrim.length
          ? dataText
          : commentTrim.length
          ? `<td class="left break-all">${commentText}</td>`
          : '';
        let commentArea = dataTrim.length && commentTrim.length ? commentText : '';

        subHTML += `<tr><th class="left">${item}</th>${contentArea}</tr>`;
        if (commentArea.length)
          subHTML += `<tr><td colspan="2" class="break-all"><textarea class="full comment" style="overflow: hidden; resize: none; height: 54px;" readonly="">${commentArea}</textarea></td></tr>`;
      });
      judgementRejectHTML += subHTML;
      judgementRejectHTML += '</tbody></table>';
    });
    return judgementRejectHTML;
  }

  public getTuiGrid(): any {
    return (this.$refs.gridArea as any).$refs.tuiGrid;
  }

  public getTuiGridOfStockSync(): any {
    return (this.$refs.gridAreaOfStockSync as any).$refs.stockSyncTuiGrid;
  }

  public renderGridByProductNo(mallProductNo: number, cloumnName: string): void {
    const grid = this.getTuiGrid();
    this.$api
      .getProductsMallProductNo({
        pathParams: {
          mallProductNo: mallProductNo.toString(),
        },
      })
      .then(({ data: { comparingPriceSiteInfo, promotionInfo } }: any): void => {
        const row = grid.invoke('findRows', {
          mallProductNo,
        });
        let data: any;
        if (cloumnName === 'priceComparisonSite') {
          data = { ...comparingPriceSiteInfo };
        } else if (cloumnName === 'canPromotion') {
          data = promotionInfo.promotionYn === 'Y' ? true : false;
        }
        setTimeout((): void => {
          const { rowKey } = row[0];
          grid.invoke('setValue', rowKey, cloumnName, data);
        });
      });
  }

  public stockSyncClose(): void {
    this.stockSyncIsShow = false;
  }

  public commissionRateBlur(e: any): void {
    this.searchParams['commission.range.min'] = this.searchParams['commission.range.min'] - 0;
    this.searchParams['commission.range.max'] = this.searchParams['commission.range.max'] - 0;
    const rangeMin: number = this.searchParams['commission.range.min'];
    const rangeMax: number = this.searchParams['commission.range.max'];

    if (rangeMin > rangeMax) {
      alert(this.pDI18n('MMINIMUM_VALUE_CANNOT_BE_GREATER'));
      const id = e.target.id;
      if (id === 'commission.range.min') {
        this.searchParams['commission.range.min'] = 0;
      } else {
        this.searchParams['commission.range.max'] = 100;
      }
    }
  }

  public async created(): Promise<any> {
    if (this.malls.length > 1 && !this.malls.find((item: any): boolean => item.value === '')) {
      this.malls.unshift({ value: '', label: this.pDI18n('PLD_SHOPPING_MALL') });
    } else if (this.malls.length === 1) {
      this.searchParams['mallNos'] = this.malls[0].value;
      this.searchParamsResetData['mallNos'] = this.malls[0].value;
    }

    if (this.$route.query.applyStatusType) {
      this.searchParams['applyStatusType'] = this.$route.query.applyStatusType as string;
      this.applyStatusTypeChange();

      if (this.$route.query.applyStatusType === 'AFTER_APPROVAL_READY') {
        this.searchParams['periodInfo.type'] = 'PRODUCT_MODIFIED_DATE';
      }
    }

    if (this.$route.query.saleStatusType) {
      this.saleStatusData = ['ON_SALE'];
      this.saleSettingStatusData = ['AVAILABLE_FOR_SALE'];
    }

    if (this.$route.query.stockRange) {
      this.stockRangeChange(this.$route.query.stockRange);
      if (Number(this.$route.query.stockRange) > 0) {
        this.saleStatusData = ['ON_SALE'];
        this.saleSettingStatusData = ['AVAILABLE_FOR_SALE'];
      }
    }

    if (this.$route.query.remainDays) {
      this.dateFilterChange(1);

      Object.assign(this.dateReceiveData, {
        startYmd: this.today,
        endYmd: momentAdd(this.today, [Number(this.$route.query.remainDays), 'd'], 'YYYY-MM-DD'),
      });
      Object.assign(this.dateData, {
        startYmd: this.dateReceiveData.startYmd,
        endYmd: this.dateReceiveData.endYmd,
      });

      this.searchParams['periodInfo.type'] = 'SALE_END_DATE';
      this.saleStatusData = ['ON_SALE'];
      this.saleSettingStatusData = ['AVAILABLE_FOR_SALE'];
    } else {
      this.setStartYmd();
    }

    this.getCustomProperty();

    this.setPopIsExist(true);
    this.$api.getProductsSummaries().then((response): any => {
      this.productsSummaries = Object.assign({}, response.data);
    });

    const { data } = await this.$api.getProductsDetailUrls();

    this.productDetailUrlObj = data;
  }

  public tableTitle = '';
  public currentFocusedRowKey = -1;

  public mounted(): void {
    this.tableTitle = this.pDI18n('LIST_TABLE_TITLE');
    renderGridByProductNo = this.renderGridByProductNo;
    this.categoiesCascade = this.$refs.categoiesCascade as any;
    // this.saleStatusTypeCheckBox = this.$refs.saleStatusTypeCheckBox as any;

    $('#tui-grid-productlist, #tui-grid-productlistOfStockSync').on(
      'change',
      '.gridSaleSettingStatusType',
      (e: any): void => {
        const $this = $(e.currentTarget);
        const gridId = $this
          .parents('.tui-grid-container')
          .last()
          .attr('id');
        const { mallProductNo: mallProductNos, rowKey, originalValue, frontDisplayYn } = $this.data();
        const saleSettingStatusType = ($this.val() + '') as ProductsSaleSettingStatusType;

        if (
          saleSettingStatusType === 'PROHIBITION_SALE' &&
          !confirm(this.pDI18n('PLM_IF_YOU_CHANGE_TO_PROHIBITION_OF_SALES'))
        ) {
          //판매금지로 변경 할 경우 판매재개가 불가능합니다. 판매금지로 변경하시겠습니까?
          const updateData = {
            saleSettingStatusType: originalValue,
          };
          this.updateGrid(gridId, rowKey, updateData);
          return;
        }

        const data = { saleSettingStatusType };
        if (saleSettingStatusType === 'PROHIBITION_SALE') {
          this.$api
            .putProductsFrontdisplay({
              data: {
                frontDisplayYn: 'N',
                productNos: [mallProductNos],
              },
            })
            .then(({ data: fData }: any): void => {
              if (fData.failures && fData.failures.length) {
                const updateData = {
                  saleSettingStatusType: originalValue,
                };
                this.updateGrid(gridId, rowKey, updateData);

                return alert(fData.failures[0].message);
              }

              this.$api
                .putProductsSaleStatus({
                  data: {
                    ...data,
                    productNos: [mallProductNos],
                  },
                })
                .then(({ data: sData }: any): void => {
                  if (sData.failures && sData.failures.length) {
                    this.$api.putProductsFrontdisplay({
                      data: {
                        frontDisplayYn,
                        productNos: [mallProductNos],
                      },
                    });

                    const updateData = {
                      saleSettingStatusType: originalValue,
                      frontDisplayYn,
                    };
                    this.updateGrid(gridId, rowKey, updateData);
                    return alert(sData.failures[0].message);
                  }

                  alert(this.pDI18n('PLM_IT_IS_CHANGED')); //수정되었습니다.

                  const updateData = {
                    saleSettingStatusType,
                    frontDisplayable: data['frontDisplayYn'] === 'Y',
                  };
                  this.updateGrid(gridId, rowKey, updateData);
                });
            });
        } else {
          this.$api
            .putProductsSaleStatus({
              data: {
                ...data,
                productNos: [mallProductNos],
              },
            })
            .then(({ data }: any): void => {
              if (data.failures && data.failures.length) {
                const updateData = {
                  saleSettingStatusType: originalValue,
                };
                this.updateGrid(gridId, rowKey, updateData);
                return alert(data.failures[0].message);
              }

              alert(this.pDI18n('PLM_IT_IS_CHANGED')); //수정되었습니다.

              const updateData = {
                saleSettingStatusType,
              };

              this.updateGrid(gridId, rowKey, updateData);
            });
        }
      },
    );

    $('#tui-grid-productlist, #tui-grid-productlistOfStockSync').on('change', '.gridFrontDisplayYn', (e: any): void => {
      const $this = $(e.currentTarget);
      const gridId = $this
        .parents('.tui-grid-container')
        .last()
        .attr('id');
      const { mallProductNo: mallProductNos, rowKey, originalValue } = $this.data();
      const frontDisplayYn = $this.val() as string;

      this.$api
        .putProductsFrontdisplay({
          data: {
            frontDisplayYn,
            productNos: [mallProductNos],
          },
        })
        .then(({ data }: any): void => {
          if (data.failures && data.failures.length) {
            this.updateGrid(gridId, rowKey, { frontDisplayable: originalValue === 'true' || originalValue === true });
            return alert(data.failures[0].message);
          }
          alert(this.pDI18n('PLM_IT_IS_CHANGED')); //수정되었습니다.
          this.updateGrid(gridId, rowKey, { frontDisplayable: frontDisplayYn === 'Y' });
        });
    });

    $('#tui-grid-productlist, #tui-grid-productlistOfStockSync').on('change', '.onlyAccessUrl', (e: any): void => {
      const $this = $(e.currentTarget);
      const gridId = $this
        .parents('.tui-grid-container')
        .last()
        .attr('id');
      const { mallProductNo: mallProductNos, rowKey } = $this.data();
      const urlDirectDisplayYn = $this.val() as string;

      const params = {
        mallProductNos,
      };

      this.$api.patchProducts({ params, data: { urlDirectDisplayYn } }).then((data): void => {
        if (this.gridModifyHandler(data)) {
          this.updateGrid(gridId, rowKey, { onlyAccessUrl: urlDirectDisplayYn === 'Y' ? true : false });
        }
      });
    });

    $('.content').on('click', '.gridHasOption', (e: any): void => {
      e.preventDefault();
      const $this = $(e.currentTarget);
      const mallProductNo = $this.data('mall-product-no');
      const params = { mallProductNo };

      this.$api
        .getProductsMallProductNoOptionsPurchasePrice({ params })
        .then(({ data }: NCPResponse<GetProductsMallProductNoOptionsPurchasePrice[]>): void => {
          const histories = data
            .map(({ optionValue, optionName, purchasePrice }): string => {
              const separator = '|';
              const values = optionValue.split(separator);
              const optionInfo = optionName
                .split(separator)
                .map((name, index): string => `${name} : ${values[index]}`)
                .join(` ${separator} `);
              return `<tr><td>${optionInfo}</td><td>${purchasePrice.toLocaleString()}</td></tr>`;
            })
            .join('');

          const popInfo = {
            title: this.pDI18n('PLD_SUPPLY_PRICE_OPTION_DETAIL'),
            subStyle: 'width:900px; max-height:800px; scroll-y:auto',
            footBtn: true,
            noticeBox: `
            <table class="ncp_tbl grid">
              <colgroup>
                  <col style="width: 250px;">
                  <col style="width: 200px;">
              </colgroup>
              <thead>
                <tr>
                  <th>${this.pDI18n('OPTION_INFO')}</th>
                  <th>${this.pDI18n('PLM_SUPPLY_PRICE')}</th>
                </tr>
              </thead>
              <tbody>${histories}</tbody>
            </table>
          `,
          };
          this.setPopInfo(popInfo);
          this.setPopIsShow(true);
        });
    });

    $('.content').on('click', '.gridMasterProductBtn', (e: any): void => {
      e.preventDefault();
      const $this = $(e.currentTarget);
      const mallProductNo = $this.data('mall-product-no');
      const mallNo = $this.data('mall-no');
      this.$api
        .getProductSearchForSyncStock({
          params: {
            mallProductNo,
            mallNo,
            page: 1,
            size: 500,
          },
        })
        .then(({ data }: any): void => {
          this.stockSyncData = data.contents.map((item): any => {
            const obj = { ...item };
            const customProperties = item.customProperties;
            customProperties.forEach((prop): void => {
              obj[`customProperties${prop.propertyNo}`] = prop.propertyValue;
            });
            return obj;
          });
          this.stockSyncIsShow = true;
        });
    });

    $('.content').on('click', '.gridItemProductBtn', (e: any): void => {
      e.preventDefault();
      // alert('WMS 연동된 상품입니다.');
      alert(this.$t('PRODUCT_PRODUCTLIST_WMSALERT'));
    });

    $('.content').on('click', '.gridProductChangeHistory', (e: any): void => {
      e.preventDefault();
      const $this = $(e.currentTarget);
      const mallProductNo = $this.data('mallproductno');
      const params = { mallProductNo };

      this.$api.getProductsHistories({ params }).then(({ data }: any): void => {
        let histories = '';
        data.forEach(
          ({ modifiedDate, applyStatusType, saleSettingStatusType, changeProperties, adminName }: any): void => {
            const saleSettingStatusTypeLabel = this.$t('PRODUCT_PRODUCTLIST_' + saleSettingStatusType);
            const applyStatusTypeLabel = this.applyStatusType.find(
              (item: any): boolean => item.value === applyStatusType,
            ).label;
            histories += `<tr><td>${modifiedDate}</td><td>${applyStatusTypeLabel}</td><td>${saleSettingStatusTypeLabel}</td><td class="left">${changeProperties.join(
              ' ',
            )}</td><td>${adminName}</td></tr>`;
          },
        );

        const popInfo = {
          title: this.$t('PRODUCT_PRODUCTLIST_PLM_PRODUCT_INFORMATION_CHANGE_HISTORY'), //상품정보 변경이력
          subStyle: 'width:900px; max-height:800px; scroll-y:auto',
          footBtn: true,
          noticeBox: `<table class="ncp_tbl grid">
          <colgroup>
              <col width="150">
              <col width="100">
              <col width="100">
              <col width="">
              <col width="100">
          </colgroup>
          <tbody><tr>
              <th>${this.$t('PRODUCT_PRODUCTLIST_PLM_CHANGE_DATE')}</th>
              <th>${this.$t('PRODUCT_PRODUCTLIST_PLM_APPROVAL_STATUS')}</th>
              <th>${this.$t('PRODUCT_PRODUCTLIST_PLD_SALES_SETTING_STATUS')}</th>
              <th>${this.$t('PRODUCT_PRODUCTLIST_PLM_CONTENTS')}</th>
              <th>${this.$t('PRODUCT_PRODUCTLIST_PLM_MANAGER')}</th>
          </tr>
          </tbody>${histories}</tbody>
      </table>
    `,
        };
        this.setPopInfo(popInfo);
        this.setPopIsShow(true);
      });
    });

    $('.content').on('click', '.judgementRejectBtn', (e: any): void => {
      e.preventDefault();
      const $this = $(e.currentTarget);
      const mallProductNo = $this.data('mallproductno');
      const params = { mallProductNo };

      const grid = this.getTuiGrid();
      const { rowKey } = grid.invoke('getFocusedCell');
      this.currentFocusedRowKey = rowKey;

      this.$api.getInspectionsReject({ params }).then(({ data: { rejectReasons } }: any): void => {
        const popInfo = {
          title: this.pDI18n('PLM_ITEMS_THAT_NEED_TO_BE_MODIFIED_AS_A_RESULT'), //상품심사 결과 수정필요항목
          subStyle: 'width:900px; max-height:800px; scroll-y:auto',
          customBtn: true,
          footBtn: true,
          customBtnEvent: (): void => {
            window.open('/product/edit/' + mallProductNo);
            this.setPopIsShow(false);
          },
          customBtnTxt: this.pDI18n('PLM_PRODUCT_MODIFICATION'), //상품수정
          noticeBox: `<div class="notice_box judgement_reject">
  <ul>
  <li>${this.pDI18n('PLM_THIS_ITEM_NEEDS_TO_BE_MODIFIED_FOR')}</li>
  <li>${this.pDI18n('PLM_PLEASE_CHECKMODIFY_THE_DETAILS_FOR')}</li>
  </ul>
  </div>
  <form>
  ${this.judgementRejectRenderHTML(rejectReasons)}
  </form>
    `,
        };
        this.setPopInfo(popInfo);
        this.setPopIsShow(true);
      });
    });

    $('.content').on('click', '.viewAgreementRejectBtn', (e: any): void => {
      e.preventDefault();
      const $this = $(e.currentTarget);
      const mallProductNo = $this.data('mallproductno');
      const pathParams = { mallProductNo };

      this.$api.GetSaleAgreementsmallProductNoView({ pathParams }).then(({ data: { reason } }: any): void => {
        const comment = reason ? reason.comment : '';
        const popInfo = {
          title: this.pDI18n('REJECTREASON_POP_TITLE'), //상품심사 결과 수정필요항목
          subStyle: 'width:1050px; max-height:800px; scroll-y:auto',
          customBtn: true,
          footBtn: true,
          customBtnEvent: (): void => {
            window.open('/product/edit/' + mallProductNo);
            this.setPopIsShow(false);
          },
          customBtnTxt: this.pDI18n('PLM_PRODUCT_MODIFICATION'), //판매합의거부 사유
          noticeBox: `<div class="notice_box judgement_reject">
        <ul>
        <li>${this.pDI18n('REJECTREASON_ITEM1')}</li>
        <li>${this.pDI18n('REJECTREASON_ITEM2')}</li>
        </ul>
        </div>
        <div id="rejectSection" class="reject_wrap" style="border-top:0px; margin-top:0px; padding-top:10px;">
        <textarea name="rejectReason" class="count_target" id="rejectReason" cols="30" rows="10" maxlength="300" readonly="">${comment}</textarea>
        <div class="textarea_bottom">
            <span class="count_wrap" for="rejectReason">
                <span class="count counting">${comment.length}</span>/300
            </span>
        </div>
        </div>
          `,
        };
        this.setPopInfo(popInfo);
        this.setPopIsShow(true);
      });
    });

    $('.content').on('click', '.deleteMallProduct', (e: any): void => {
      e.preventDefault();
      const result = confirm(this.pDI18n('DELETE_COMFIRM_TXT')); //삭제하신 상품은 판매가 불가능합니다. 정말 삭제하시겠습니까?
      if (result) {
        const $this = $(e.currentTarget);
        const mallProductNos = $this.data('mallProductNo');
        const mallNo = $this.data('mallNo');
        const data = { mallNo, mallProductNos };

        this.$api.deleteProducts({ data }).then((res: any): void => {
          if (res.status === 204) {
            this.search();
          }
        });
      }
    });

    $('#content').on('click', '.ncp_layerpopup button', (e: any): void => {
      e.preventDefault();
      if (this.currentFocusedRowKey === -1) return;
      const $this = $(e.currentTarget);

      const {
        isStockSync: syncStockYn,
        saleMethodType,
        applyStatusType,
        mallNo,
        salePrice,
        appliedImmediateDiscountPrice,
        appliedAdditionalDiscountPrice,
        commission: { rate: commissionRate, type: commissionRateType },
        isItem: itemYn,
        deliveryTemplateNo,
        mallProductNo,
        optionType,
        categoryNo,
        reservationPeriod,
      } = { ...this.searchRespones.contents[this.currentFocusedRowKey] } as any;

      const params = {
        syncStockYn,
        mallNo,
        saleMethodType,
        applyStatusType,
        salePrice,
        appliedImmediateDiscountPrice,
        appliedAdditionalDiscountPrice,
        commissionRate,
        commissionRateType,
        itemYn,
        deliveryTemplateNo,
        mallProductNo,
        optionType,
        categoryNo,
        isDirectSave: true,
      };

      if ($this.hasClass('optionActionBtn')) {
        const btnType = $this.data('type');

        const paramStrAddModi = $.param(
          Object.assign(params, { useReservationStock: reservationPeriod ? true : false }),
        );
        const paramStr = $.param(params);

        switch (btnType) {
          case 'add':
            // 등록 (몰 & 판매가 입력 필수)
            window.open(`/option/addForm?${paramStrAddModi}`, 'add_optionForm', centerWinOptions(1180, 730));
            break;
          case 'modify':
            // 변경
            window.open(`/option/addForm?${paramStrAddModi}`, 'modify_optionForm', centerWinOptions(1180, 730));
            break;
          case 'before':
            window.open(
              `/option/addForm?readonly=true&editYn=Y&useReservationStock=false&${paramStr}`,
              'before_optionForm',
              centerWinOptions(1180, 730),
            );
            break;
          case 'reset':
            // TODO
            break;
          case 'after':
          default:
            window.open(
              `/option/addForm?readonly=true&editYn=Y&targetId=judgement_optionData&useReservationStock=false&${paramStr}`,
              'after_optionForm',
              centerWinOptions(1180, 730),
            );
            break;
        }
      }

      if ($this.attr('id') === 'judgement_dutyInfoBtn') {
        window.open(
          `/productDuty/readFormForAgreement?parentDutyInfoId=judgement_dutyInfo&mallProductNo=${params.mallProductNo}`,
          this.$t('PRODUCT_ADD_DUTY_CONTENT_TITLE') as string,
          centerWinOptions(1034, 782),
        );
      }
      if ($this.attr('id') === 'after_judgement_DutyInfoBtn') {
        let ID = $(e.target)
          .parent()
          .siblings('input')
          .attr('id');
        window.open(
          `/productDuty/readFormForAgreement?parentDutyInfoId=${ID}&mallProductNo=${params.mallProductNo}`,
          this.$t('PRODUCT_ADD_DUTY_CONTENT_TITLE') as string,
          centerWinOptions(1034, 782),
        );
      }
      if ($this.attr('id') === 'judgement_certificationJsonBtn') {
        window.open(
          '/certification/readFormForAgreement?parentDutyInfoId=judgement_certificationJsonInfo&categoryNo=' +
            categoryNo,
          this.$t('PRODUCT_JUDGEMENT_POP_CERTIFICATION_INFO') as string,
          centerWinOptions(1034, 782),
        );
      }
      if ($this.attr('id') === 'after_judgement_CertificationJsonBtn') {
        window.open(
          '/certification/readFormForAgreement?parentDutyInfoId=judgement_certificationJsonInfo&categoryNo=' +
            categoryNo,
          this.$t('PRODUCT_JUDGEMENT_POP_CERTIFICATION_INFO') as string,
          centerWinOptions(1034, 782),
        );
      }

      if ($this.attr('id') === 'judgementRejectResult_editProduct') {
        window.open('/product/edit/' + params.mallProductNo);
      }
    });

    $('.content').on(
      'click',
      '.memberDisplay',
      async (e: any): Promise<any> => {
        const $this = $(e.currentTarget);
        const { mallNo, info, type, check } = $this.data();
        const params = { mallNo: Number(mallNo) };
        let displayData = [];

        if (type === 'Grade') {
          const { data } = await this.$api.getMemberGrades({ params });
          const infoList = data.filter(({ used }: any): boolean => used);
          if (check === 'ALL') {
            displayData = infoList.map(({ name }): any => name);
          } else if (check === 'ANY') {
            displayData = info.map((no: any): any => {
              const result = infoList.find((item: any): boolean => item.no === no);
              if (result) {
                return result.name ? result.name : '';
              } else {
                return '';
              }
            });
          }
        } else if (type === 'Group') {
          const { data: infoList } = await this.$api.getMemberGroups({ params });
          if (check === 'ALL') {
            displayData = infoList.map(({ name }): any => name);
          } else if (check === 'ANY') {
            displayData = info.map((no: any): any => {
              const result = infoList.find((item: any): boolean => item.no === no);
              if (result) {
                return result.name ? result.name : '';
              } else {
                return '';
              }
            });
          }
        }

        const typeText = type === 'Grade' ? this.pDI18n('RANKING') : this.pDI18n('GROUP');
        const text =
          check === 'ALL'
            ? `${this.pDI18n('ALL_MEMBERS')}${typeText}`
            : info.length > 0 && !displayData.length
            ? `${this.pDI18n('MEMBER')}${typeText} ${this.pDI18n('UNSELECTED')}`
            : displayData.join('')
            ? displayData.join(', ')
            : displayData.join('');
        const title = `${this.pDI18n('MEMBER')}${typeText} ${this.pDI18n('VIEW_SETTINGS')}`;
        const popInfo = {
          title,
          subStyle: 'width:750px; max-height:500px; scroll-y:auto',
          footBtn: true,
          noticeBox: `<table class="ncp_tbl"><tbody><tr><th>${this.pDI18n('MEMBER')}${typeText} ${this.pDI18n(
            'EXPOSURE_SETTING',
          )}</th><td>${text}</td></tr></tbody></table>`,
        };

        this.setPopInfo(popInfo);
        this.setPopIsShow(true);
      },
    );
  }
}
